import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerMaterialKeys } from '@/api/query-keys';
import {
  listPartnerMaterialsAdminContract,
  type ListPartnerMaterialsAdminResponse,
  type PartnerMaterialAdmin
} from '@bliks-io/contracts';

/** Every partner material, inactive ones included (superadmin). */
export function useAdminPartnerMaterials() {
  return useQuery({
    queryKey: partnerMaterialKeys.admin(),
    queryFn: async ({ signal }): Promise<PartnerMaterialAdmin[]> => {
      const { data } = await apiClient.get<ListPartnerMaterialsAdminResponse>(
        listPartnerMaterialsAdminContract.path,
        { signal }
      );
      return data.data;
    }
  });
}
